import { create } from 'zustand';
import { botsApi } from '../api';

const useBotStore = create((set, get) => ({
  bots: [],
  currentBot: null,
  flow: null,
  blocks: [],
  isLoading: false,
  error: null,

  setBots: (bots) => set({ bots }),

  setCurrentBot: (bot) => set({ currentBot: bot }),

  setFlow: (flow) => set({ flow }),

  setBlocks: (blocks) => set({ blocks }),

  fetchBots: async (params) => {
    set({ isLoading: true, error: null });
    try {
      const response = await botsApi.getAll(params);
      set({ bots: response.data.data || response.data, isLoading: false });
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to fetch bots', isLoading: false });
      throw error;
    }
  },

  fetchBotById: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const response = await botsApi.getById(id);
      set({ currentBot: response.data, isLoading: false });
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to fetch bot', isLoading: false });
      throw error;
    }
  },

  createBot: async (data) => {
    set({ isLoading: true, error: null });
    try {
      const response = await botsApi.create(data);
      set((state) => ({
        bots: [...state.bots, response.data],
        isLoading: false
      }));
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to create bot', isLoading: false });
      throw error;
    }
  },

  updateBot: async (id, data) => {
    set({ isLoading: true, error: null });
    try {
      const response = await botsApi.update(id, data);
      set((state) => ({
        bots: state.bots.map(bot => bot.id === id ? response.data : bot),
        currentBot: state.currentBot?.id === id ? response.data : state.currentBot,
        isLoading: false
      }));
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to update bot', isLoading: false });
      throw error;
    }
  },

  deleteBot: async (id) => {
    set({ isLoading: true, error: null });
    try {
      await botsApi.delete(id);
      set((state) => ({
        bots: state.bots.filter(bot => bot.id !== id),
        currentBot: state.currentBot?.id === id ? null : state.currentBot,
        isLoading: false
      }));
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to delete bot', isLoading: false });
      throw error;
    }
  },

  fetchFlow: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const response = await botsApi.getWaFlow(id);
      set({ flow: response.data, isLoading: false });
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to fetch flow', isLoading: false });
      throw error;
    }
  },

  fetchBlocks: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const response = await botsApi.getWaBlocks(id);
      set({ blocks: response.data, isLoading: false });
      return response.data;
    } catch (error) {
      set({ error: error.response?.data?.message || 'Failed to fetch blocks', isLoading: false });
      throw error;
    }
  },

  clearError: () => set({ error: null }),

  reset: () => set({ bots: [], currentBot: null, flow: null, blocks: [], isLoading: false, error: null }),
}));

export default useBotStore;
